<template>
   <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="critereRecherche">
     <div class="column is-12 pdb-0">
        <div class="column is-12 mgt-5px">
         <a @click="$emit('toggleFiltre')">
            <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
         </a>
         <span class="has-text-weight-bold is-size-4">
            {{ $t('stock.filtre.title') }}
         </span>
        </div>
        <div class="column is-12 pdt-0">
          <span class="has-text-icon-more is-size-7">
            {{ $t('stock.filtre.sousTitle') }}
          </span>
        </div>
     </div>
     <div class="column is-12 is-marginless overflow-auto hauteur-brief-filtre">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 pdb-0">
          <input-periode
            v-model="datesDeBon"
            :label="$t('stock.filtre.periode')">
          </input-periode>
        </div>
        <div class="column is-12 pdb-0">
            <query-tiers-tag-input
               :label="$t('stock.informations.lieuDeStockage')"
               typologie="all"
               :estLieuStockage="true"
               v-model="lieuDeStockage"
               :societeActiveId="this.societeActiveId"></query-tiers-tag-input>
         </div>
         <div class="column is-12 pdb-0">
          <b-field :label="$t('stock.filtre.origine')">
            <b-select v-model="critereRecherche.origine">
               <option :value="null"></option>
              <option :value="constantes.ORIGINE_TYPE_COMMANDE">
                  {{ $t('stock.origineType.commande') }} </option>
              <option :value="constantes.ORIGINE_TYPE_DIVERS">
                  {{ $t('stock.origineType.bonDivers') }} </option>
            </b-select>
          </b-field>
         </div>
         <div class="column is-12 pdb-0">
          <query-tag-input
            :label="$t('stock.filtre.commande')"
            v-model="commandes"
            field="code"
            :query="(search) => getAllCommande({
              query: {
                code: search,
                societeId: this.societeActiveId,
                sens: sens,
              },
            })">
            <template slot-scope="props">
              <div>{{ props.option.code }}</div>
            </template>
          </query-tag-input>
         </div>
         <div class="column is-12 pdb-0">
          <b-field :label="$t('stock.filtre.actif')">
            <b-select v-model="critereRecherche.actif">
              <option :value="null"></option>
              <option value="true">
                  {{ $t('general.oui') }} </option>
              <option value="false">
                  {{ $t('general.non') }} </option>
            </b-select>
          </b-field>
         </div>
      </div>
     </div>
     <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
              @click="appliquerCritere()">
        {{ $t('stock.filtre.actions.appliquer') }}
      </button>

      <button @click="viderCritere()"
              class="button border-none mgt-10px has-text-icon-more pd-10px">
        {{ $t('stock.filtre.actions.reinitialiser') }}
      </button>
    </div>
   </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import inputPeriode from '@/components/general/inputPeriode';
import queryTiersTagInput from '@/components/general/tagInput/queryTiersTagInput';
import {
  ORIGINE_TYPE_COMMANDE,
  ORIGINE_TYPE_DIVERS,
} from '@/configuration/bonStock/menuStockConf';
import { getAll as getAllCommande } from '@/api/commande';
import { createNamespacedHelpers } from 'vuex';
import { SENS_VENTE } from '@/configuration/devisConf';
import queryTagInput from '@/components/general/tagInput/queryTagInput';
import messageErreur from '@/services/general/messageErreur';
import genererCritereRechercheStock from '@/services/gabed/bonStock/generer/genererCritereRechercheStock';
import formatDate from '@/services/general/formatDate';

const parametres = createNamespacedHelpers('parametres');
const societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      critereRecherche: null,
      isFetching: false,
      constantes: {
        ORIGINE_TYPE_COMMANDE,
        ORIGINE_TYPE_DIVERS,
      },
      filtered: [],
      getAllCommande,
      datesDeBon: {
        dateDebut: null,
        dateFin: null,
      },
      lieuDeStockage: [],
      commandes: [],
    };
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    sens: {
      type: String,
      default: SENS_VENTE,
    },
    isEntree: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    inputPeriode,
    queryTiersTagInput,
    queryTagInput,
  },
  computed: {
    ...parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    storeName() {
      return this.isEntree ? 'bonStockEntree' : 'bonStockSortie';
    },
    lastPayload() {
      return this.$store.getters[`${this.storeName}/lastPayload`];
    },
    total() {
      return this.$store.getters[`${this.storeName}/total`];
    },
    items() {
      return this.$store.getters[`${this.storeName}/items`];
    },
  },
  methods: {
    setCritereRecherche(value) {
      this.$store.commit(`${this.storeName}/SET_CRITERE_RECHERCHE`, value);
    },
    initializeFiltre() {
      this.critereRecherche = cloneDeep(this.value);
      if (this.critereRecherche.dateDeBon.dateDebut) {
        this.datesDeBon.dateDebut = new Date(this.value.dateDeBon.dateDebut);
      }
      if (this.critereRecherche.dateDeBon.dateFin) {
        this.datesDeBon.dateFin = new Date(this.value.dateDeBon.dateFin);
      }
      this.lieuDeStockage = [];
      this.commandes = [];
    },
    reinitialiserDate() {
      return {
        dateDebut: null,
        dateFin: null,
      };
    },
    async appliquerCritere() {
      const loadingComponent = this.$buefy.loading.open();
      this.critereRecherche.dateDeBon = this.reinitialiserDate();
      try {
        if (this.datesDeBon.dateDebut) {
          this.critereRecherche.dateDeBon.dateDebut = formatDate(this.datesDeBon.dateDebut);
        }
        if (this.datesDeBon.dateFin) {
          this.critereRecherche.dateDeBon.dateFin = formatDate(this.datesDeBon.dateFin);
        }
        this.critereRecherche.codesCommande = this.commandes.map(c => c.code);
        this.critereRecherche.societeId = this.societeActiveId;
        this.critereRecherche.lieuDeStockageIds = this.lieuDeStockage.map(lieu => lieu.id);
        this.setCritereRecherche(this.critereRecherche);
        await this.$emit('recherche');
      } catch (e) {
        messageErreur(this.$i18n);
        throw (e);
      } finally {
        loadingComponent.close();
      }
    },
    viderCritere() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.critereRecherche = cloneDeep(genererCritereRechercheStock());
        this.lieuDeStockage = [];
        this.commandes = [];
        this.datesDeBon = this.reinitialiserDate();
        this.critereRecherche.societeId = this.societeActiveId;
        this.setCritereRecherche(this.critereRecherche);
        this.$emit('recherche');
      } catch (e) {
        messageErreur(this.$i18n);
        throw (e);
      } finally {
        loadingComponent.close();
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
